"use client"

import { VoteStatus, RaffleStatus } from "@repo/loomlock/client"
import {
  IVote,
  IRaffle,
  IGiveaway,
  GiveawayStatus,
  type IGachabox,
  type GachaboxStatus,
} from "@repo/loomlock/model-types"
import { EventCard } from "./EventCard"
import { useState } from "react"
import { cn } from "@abraxas/ui/lib"

interface MonthGroupProps {
  month: string
  events: Array<
    | (IVote & { status?: VoteStatus })
    | (IRaffle & { status?: RaffleStatus })
    | (IGiveaway & { status?: GiveawayStatus })
    | (IGachabox & { status?: GachaboxStatus })
  >
  defaultExpanded?: boolean
}

export function MonthGroup({
  month,
  events,
  defaultExpanded = true,
}: MonthGroupProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  if (events.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-3 w-full">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full"
      >
        <p className="font-semibold text-body-l text-white whitespace-pre">
          {month}
        </p>
        <svg
          className={cn(
            "size-8 transition-transform",
            isExpanded ? "" : "rotate-180",
          )}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 12L16 20L24 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isExpanded && (
        <div className="flex flex-col gap-4 w-full">
          {events.map((event) => (
            <EventCard key={event.slug} event={event} className="w-full" />
          ))}
        </div>
      )}
    </div>
  )
}
